(function () {
  $(document).on('gform_post_render', function (event, form_id, current_page) {
    // Reinit all fselect that might just have been created.
    if ('undefined' !== typeof VTX_FSelect) {
      VTX_FSelect.init();
    }
  });
})();